import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const problems = [{
  num: '1/4',
  title: 'Años entrenando sin entender el juego desde el N°9',
  sin: 'Jugás de medio scrum pero nadie te enseñó la mecánica real del pase, la salida del ruck y la lectura táctica que separa al N°9 de club del N°9 que llega al seleccionado provincial.',
  con: 'Sistema completo de desarrollo para el Medio Scrum: técnica de pase, posicionamiento, comunicación con el N°10 y los forwards, y mentalidad del N°9 élite.'
}, {
  num: '2/4',
  title: 'Jugás de apertura pero nadie te enseñó a dirigir el partido',
  sin: 'Recibís el balón y reaccionás. No leés la defensa con anticipación, no gestionás el marcador y el DT no te ve como el director que necesita.',
  con: 'Manual completo del N°10 argentino moderno: lectura táctica previa, kick estratégico, comunicación con backs y forwards, y la mentalidad del apertura que gana partidos.'
}];
const manuals = [{
  id: 'U1',
  title: 'EL NUEVE QUE MUEVE',
  subtitle: 'Manual Élite del Medio Scrum Argentino (50 págs)',
  desc: 'El sistema completo para dominar la posición más influyente del rugby argentino moderno.',
  bullets: ['Técnica de pase: mecánica, distancia y timing bajo presión', 'Decisión táctica: cuándo pasar, patear o correr', 'Defensa del N°9 que nadie enseña en el club', 'Mentalidad y liderazgo desde el N°9', 'Plan de desarrollo con drills específicos', 'Lo que hacen diferente Bertranou y Cubelli']
}, {
  id: 'U2',
  title: 'EL DIEZ MANDA',
  subtitle: 'Manual Élite de la Apertura Argentina (50 págs)',
  desc: 'El director de orquesta que todo equipo argentino necesita y muy pocos saben realmente ser.',
  bullets: ['Lectura de la defensa antes de recibir el balón', 'Kick territorial, up and under y chip kick: cuándo y cómo', 'Comunicación táctica con backs y forwards en tiempo real', 'Gestión del marcador: cómo jugar ganando y perdiendo', 'Mentalidad bajo presión: los peores momentos del partido', 'Lo que hacen diferente Contepomi y Berchesi']
}];
export function EliteUpsell() {
  return <section className="py-14 md:py-24 bg-rugby-green-950 relative border-t border-rugby-green-800" data-id="element-139">
      <div className="container mx-auto px-4" data-id="element-140">
        <div className="max-w-4xl mx-auto" data-id="element-141">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-142">
            <h2 className="text-2xl md:text-5xl font-display text-white mb-2 md:mb-4 leading-tight" data-id="element-143">
              ¿QUÉ AGREGA EL RUGBY PRO KIT ÉLITE?
            </h2>
            <p className="text-sm md:text-xl text-rugby-gold-400 font-serif italic px-2" data-id="element-144">
              Para jugadores que van por la posición más influyente del rugby
              argentino moderno
            </p>
          </motion.div>

          <div className="space-y-6 md:space-y-12 mb-10 md:mb-20" data-id="element-145">
            {problems.map((p, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-rugby-green-900 border border-rugby-green-700 rounded-2xl overflow-hidden" data-id="element-146">
                <div className="bg-rugby-green-950 p-3 md:p-4 border-b border-rugby-green-800 flex items-center gap-2 md:gap-3" data-id="element-147">
                  <span className="text-red-500 text-base md:text-xl" data-id="element-148">🔴</span>
                  <span className="text-slate-400 font-bold text-xs md:text-sm tracking-wider uppercase" data-id="element-149">
                    PROBLEMA {p.num}
                  </span>
                </div>
                <div className="p-4 md:p-8" data-id="element-150">
                  <h3 className="text-base md:text-2xl font-bold text-white mb-4 md:mb-6 leading-snug" data-id="element-151">
                    {p.title}
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-152">
                    <div className="bg-rugby-green-950/50 p-4 md:p-5 rounded-xl border border-red-900/30" data-id="element-153">
                      <h4 className="text-red-400 font-bold text-xs md:text-sm mb-2 uppercase tracking-wider" data-id="element-154">
                        SIN ÉLITE:
                      </h4>
                      <p className="text-slate-400 text-xs md:text-sm leading-relaxed" data-id="element-155">
                        {p.sin}
                      </p>
                    </div>
                    <div className="bg-rugby-green-800/50 p-4 md:p-5 rounded-xl border border-rugby-gold-500/30" data-id="element-156">
                      <h4 className="text-rugby-gold-400 font-bold text-xs md:text-sm mb-2 uppercase tracking-wider" data-id="element-157">
                        CON ÉLITE:
                      </h4>
                      <p className="text-white text-xs md:text-sm leading-relaxed" data-id="element-158">
                        {p.con}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-6 md:mb-10" data-id="element-159">
            <h3 className="text-2xl md:text-3xl font-display text-white" data-id="element-160">
              RUGBY PRO KIT ÉLITE INCLUYE:
            </h3>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-161">
            {manuals.map((m, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: i === 0 ? -20 : 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} whileHover={{
            y: -4
          }} className="bg-gradient-to-b from-rugby-green-900 to-rugby-green-950 border border-rugby-gold-500/50 rounded-2xl p-5 md:p-8 relative shadow-[0_0_30px_rgba(212,175,55,0.1)] transition-shadow hover:shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-id="element-162">
                <div className="absolute -top-3 -left-3 md:-top-4 md:-left-4 bg-rugby-gold-500 text-rugby-green-950 w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-display text-lg md:text-xl shadow-lg" data-id="element-163">
                  ⭐
                </div>
                <div className="mb-4 md:mb-6 mt-2" data-id="element-164">
                  <span className="text-rugby-gold-400 font-bold text-xs md:text-sm tracking-wider uppercase mb-1 block" data-id="element-165">
                    {m.id}
                  </span>
                  <h4 className="text-xl md:text-2xl font-display text-white mb-1" data-id="element-166">
                    {m.title}
                  </h4>
                  <p className="text-slate-300 font-medium text-xs md:text-sm mb-2 md:mb-3" data-id="element-167">
                    {m.subtitle}
                  </p>
                  <p className="text-slate-400 text-xs md:text-sm italic" data-id="element-168">
                    {m.desc}
                  </p>
                </div>

                <div className="space-y-2 md:space-y-3" data-id="element-169">
                  {m.bullets.map((bullet, j) => <div key={j} className="flex items-start gap-2 md:gap-3" data-id="element-170">
                      <ArrowRight size={14} className="text-rugby-gold-500 flex-shrink-0 mt-0.5" data-id="element-171" />
                      <span className="text-slate-200 text-xs md:text-sm leading-snug" data-id="element-172">
                        {bullet}
                      </span>
                    </div>)}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}